import { getEmployees } from 'app/dataProviders/employees'
import { EmployeesListRequestParams } from 'app/common/types/employees/employees-list'

let currentAbortController: AbortController | undefined
export const getFilterEmployees = async (params: EmployeesListRequestParams) => {
  currentAbortController?.abort()
  currentAbortController = new AbortController()
  const items = await getEmployees(params, currentAbortController?.signal)
  if (items) {
    return items
  }
  return []
}
